<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAnalyticsChart_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.158 2a1 1 0 0 0-1 1v7.21a1 1 0 0 0 1 1h1.316a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7.158ZM3.474 4.947a1 1 0 0 0-1 1v4.263a1 1 0 0 0 1 1h.947a1 1 0 0 0 1-1V5.947a1 1 0 0 0-1-1h-.947Zm6.736 1a1 1 0 0 1 1-1h.948a1 1 0 0 1 1 1v4.263a1 1 0 0 1-1 1h-.947a1 1 0 0 1-1-1V5.947Zm-8.473 6.369a.737.737 0 0 0 0 1.473h12.526a.737.737 0 0 0 0-1.473H1.737Z"
        clip-rule="evenodd"
    />
</svg>
